import { render, staticRenderFns } from "./noDiscipline.vue?vue&type=template&id=165a6fc4&"
import script from "./noDiscipline.vue?vue&type=script&lang=js&"
export * from "./noDiscipline.vue?vue&type=script&lang=js&"
import style0 from "./noDiscipline.vue?vue&type=style&index=0&lang=scss&scope=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports